import { render, staticRenderFns } from "./cediStock.vue?vue&type=template&id=00bec1e2&"
import script from "./cediStock.vue?vue&type=script&lang=js&"
export * from "./cediStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports